module.exports = __webpack_public_path__ + "img/IC_Msg_Information.040f018e.svg";